import { DataExtractionFieldHeader } from '@/models';

export function getIconForType(typeName) {
  switch (typeName) {
    case 'DataExtractionFieldHeader':
      return 'format_size';
    case 'DataExtractionFieldText':
      return 'format_size';
    case 'DataExtractionFieldSingleSelect':
      return 'format_list_bulleted';
    case 'DataExtractionFieldMultipleSelect':
      return 'format_list_bulleted';
  }

  return '';
}

export function splitFieldListIntoGroups(fields) {
  const groups = [];
  let nextGroup = null;
  const createNextGroup = () => {
    nextGroup = {
      header: null,
      fields: [],
      id: groups.length,
    };
  };
  const addCurrentGroup = () => {
    if (nextGroup) {
      groups.push(nextGroup);
      nextGroup = null;
    }
  };

  for (const field of fields) {
    if (field instanceof DataExtractionFieldHeader) {
      if (nextGroup) {
        addCurrentGroup();
      }
      createNextGroup();
      nextGroup.header = field;
    } else {
      if (!nextGroup) {
        createNextGroup();
      }
      nextGroup.fields.push(field);
    }
  }
  if (nextGroup !== null) {
    addCurrentGroup();
  }
  return groups;
}
